import { useAcctCurrency } from "./useAcctCurrency";

// تنسيق موحّد للمبالغ: فواصل ألوف + منزلتان عشريتان + رمز عملة.
// إن مُرِّرت `currency` صراحةً تُستخدم، وإلا يُقرأ من نطاق الفرع الحالي.
export const formatMoney = (value, currency = "AED") => {
  const num = Number(value);
  if (!Number.isFinite(num)) return `— ${currency}`;
  const abs = Math.abs(num);
  const formatted = abs.toLocaleString("en-US", {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  });
  const sign = num < 0 ? "-" : "";
  return `${sign}${formatted} ${currency}`;
};

export const Money = ({ value, currency, className = "", testid, dim = false }) => {
  const fallback = useAcctCurrency();
  const code = (currency || fallback).toUpperCase();
  return (
    <span dir="ltr" data-testid={testid}
          className={`num font-mono ${dim ? "text-muted-foreground" : ""} ${className}`}>
      {formatMoney(value, code)}
    </span>
  );
};
